<script setup lang="ts">
import { computed, onScopeDispose, ref } from 'vue'

import { useRouter } from 'vue-router'

const THROTTLE_MS = 120
const STEP_MS = 180
const HIDE_MS = 300

const progress = ref(0)
const visible = ref(false)

let startTimer: ReturnType<typeof setTimeout> | undefined
let stepTimer: ReturnType<typeof setInterval> | undefined
let hideTimer: ReturnType<typeof setTimeout> | undefined

function clearTimers() {
  clearTimeout(startTimer)
  clearInterval(stepTimer)
  clearTimeout(hideTimer)
}

function start() {
  clearTimers()
  startTimer = setTimeout(() => {
    visible.value = true
    progress.value = 12
    stepTimer = setInterval(() => {
      progress.value = Math.min(progress.value + (92 - progress.value) * 0.18, 92)
    }, STEP_MS)
  }, THROTTLE_MS)
}

function finish() {
  clearTimers()
  if (!visible.value) return
  progress.value = 100
  hideTimer = setTimeout(() => {
    visible.value = false
    progress.value = 0
  }, HIDE_MS)
}

const router = useRouter()
const stopBefore = router.beforeEach(() => {
  start()
  return true
})
const stopAfter = router.afterEach(finish)
const stopError = router.onError(finish)

onScopeDispose(() => {
  clearTimers()
  stopBefore()
  stopAfter()
  stopError()
})

const style = computed(() => ({
  transform: `scaleX(${progress.value / 100})`,
  opacity: visible.value ? '1' : '0',
}))
</script>

<template>
  <div
    data-slot="navigation-progress"
    class="pointer-events-none fixed inset-x-0 top-0 z-50 h-0.5 origin-left bg-primary transition-[transform,opacity] duration-200 ease-out"
    :style="style"
    role="presentation"
  />
</template>
